import { type ReactElement } from "react";
import { useDarkMode, useLanguage } from "@/context";
import { t } from "@/data";

export const Footer = (): ReactElement => {
  const { modeClass } = useDarkMode();
  const { lang } = useLanguage();

  return (
    <footer className={`footer ${modeClass}`}>
      &copy; {new Date().getFullYear()} {t(lang, "copyright")}
      <a href="https://www.dangwebs.com" target="_blank" rel="noopener noreferrer">
        DangWebs.com
      </a>
    </footer>
  );
};
